import { useState } from "react";
import { connect } from "react-redux";

import { genders, programLevels } from "../../../constants";

import { ShowModal, SetModalProperties } from "../../../redux/v2/utils/actions";
import { GenerateScheduleOldUser, LoadAccountDetails, } from "../../../redux/v2/user/actions";

import useSVG from "../../../hooks/useSVG";
import usePrograms from "../../../hooks/usePrograms";
import { socketS2 } from "../../../utils/socket";

import CustomProgressCircularLoader from "../../../common/CustomProgressCircularLoader";
import CustomButton from "../../../common/CustomButton";
import { delay } from "../../../utils";

function WorkoutPlanModal(props) {
    const { account } = props.User;
    const { programs } = props.Program;

    const { selectedProgram } = props;
    const { UseProgramSVG } = useSVG();
    const { GetSelectedPrograms } = usePrograms({ programs: programs });

    const [ongoingUpdateInWP, setOngoingUpdateInWP] = useState(false);
    const [wpProgress, setWPProgress] = useState({ progress: 0, message: "Working on it" });
    const [isFinished, setIsFinished] = useState(false);

    const gradient = selectedProgram?.gradient?.split("-")
    const svgKey = `${programLevels?.[selectedProgram?.level]?.toLowerCase()}${selectedProgram?.svg}`;
    const svg = UseProgramSVG(svgKey);
    const programName = `${selectedProgram?.title} ${programLevels?.[selectedProgram?.level]}`;

    const onboardingDetail = account?.onboardingDetails?.[account?.onboardingDetails?.length - 1];
    const programsInWP = onboardingDetail?.programs?.split(",");
    const detailedProgramsInWP = GetSelectedPrograms(programsInWP || []);

    const ListenWPProgress = (id) => {
        socketS2.removeAllListeners(`update-workout-plan-generate-progress-${id}`);
        socketS2.on(`update-workout-plan-generate-progress-${id}`, (data) => {
            setWPProgress(data?.data);
        });
    };


    return (
        <>
            <div id="ov2-wp-update-modal">

                <div id="ov2-wp-um-card-icon">
                    <div style={{ backgroundImage: `linear-gradient(to right, ${gradient?.[0]}, ${gradient?.[1]})` }}>
                        {svg}
                    </div>
                </div>
                <div id="ov2-wp-um-header">
                    {
                        !isFinished
                            ? <h4 className="t-capitalize">Add {programName}</h4>
                            : <h4>Success</h4>
                    }
                </div>
                <div id="ov2-wp-um-content">
                    <div id="ov2-wp-um-description">
                        {!isFinished
                            ? <>
                                {
                                    !ongoingUpdateInWP
                                        ? <h5>You have an available slot in your workout plan. Would you like to add {programName}?</h5>
                                        : <div id="ov2-wp-um-cpcl-wrapper" >
                                            <CustomProgressCircularLoader wpProgress={wpProgress} />
                                            <em>Updating workout plan...</em>
                                        </div>
                                }

                            </>
                            : <h5>{programName} was added to your workout plan </h5>
                        }

                        {!isFinished
                            ? <>
                                {!ongoingUpdateInWP && <>
                                    <CustomButton style={{ marginTop: "10px" }} onClick={async () => {
                                        if (!ongoingUpdateInWP) {
                                            ListenWPProgress(account?.user?.id);
                                            setOngoingUpdateInWP(true);
                                            const payload = {
                                                "personalInfo":
                                                {
                                                    "dob": account?.user?.dob,
                                                    "firstName": account?.user?.first_name,
                                                    "gender": genders?.[account?.user?.gender],
                                                    "lastName": account?.user?.last_name
                                                },
                                                "daysToWorkout": onboardingDetail?.preferred_days ? JSON.parse(onboardingDetail?.preferred_days) : "",
                                                "minutesPerWeek": onboardingDetail?.preferred_min_per_week,
                                                "consistency": onboardingDetail?.consistency,
                                                "preferedWorkoutLength": onboardingDetail?.preferred_workout_length,
                                                "goals": [],
                                                "programs": [...detailedProgramsInWP, { ...selectedProgram }]
                                            }
                                            const res = await props.GenerateScheduleOldUser(payload);
                                            if (res) {
                                                setOngoingUpdateInWP(false);
                                                setIsFinished(true);
                                                props.LoadAccountDetails(false, 1);
                                                delay(() => {
                                                    setIsFinished(false);
                                                    props.ShowModal(false);
                                                    setWPProgress({ progress: 0, message: "Working on it" })
                                                }, 5000);
                                            }

                                        }
                                    }}>
                                        Add
                                    </CustomButton>

                                    <CustomButton isPrimary={false} onClick={() => {
                                        setIsFinished(false);
                                        props.ShowModal(false);
                                        setWPProgress({ progress: 0, message: "Working on it" })
                                    }}>
                                        Cancel
                                    </CustomButton>
                                </>}
                            </>
                            : <CustomButton style={{ marginTop: "10px" }} onClick={() => {
                                props.ShowModal(false);
                            }}>
                                Continue
                            </CustomButton>
                        }
                    </div>
                </div>

            </div>
        </>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
    Program: state.Program,
});

export default connect(mapStateToProps, {
    GenerateScheduleOldUser,
    ShowModal,
    SetModalProperties,
    LoadAccountDetails,
})(WorkoutPlanModal);
